import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, isRef as _isRef, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ae12234"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal_contens_list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["name", "value"]
const _hoisted_4 = { class: "radio_text" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["name", "value"]
const _hoisted_8 = { class: "radio_text" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "radio"
}
const _hoisted_11 = ["name", "value"]
const _hoisted_12 = { class: "radio_text" }

import { PropType, computed, ref, Ref, watchEffect, watch } from 'vue';
import { RadioListType } from '@/types';
type AccordionItemType = {
  type: 'default' | 'checkbox' | 'radio';
  label: string;
  value: string | number;
  isOpen: boolean;
  isSelected: boolean;
  hasChildren: boolean;
  children: AccordionItemType[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'AccordionRadio',
  props: {
  name: {
    type: String,
    default: '',
  },
  list: {
    type: Array as PropType<RadioListType[]>,
    default() {
      return [];
    },
  },
  modelValue: {
    type: [String, Number] as PropType<string | number | null>,
    default: '',
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: number | string | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const value = computed({
  get: () => {
    return props.modelValue;
  },
  set: (value) => {
    emit('update:modelValue', value);
  },
});
const toggleAccordion = (item: AccordionItemType) => {
  if (item.hasChildren) {
    item.isOpen = !item.isOpen;
  }
};
/**
 * チェックされているか（valueの中にlistItemValueが含まれているか）
 */
const isChecked = (listItemValue: string | number) => {
  return value.value === listItemValue;
};

const propList = computed(() => props.list);
const list: Ref<AccordionItemType[]> = ref([]);

watch(
  propList,
  () => {
    list.value = propList.value.map((largeItem) => {
      // 子要素があるか
      const hasChildren = !!largeItem.children && largeItem.children.length > 0;

      const middle = hasChildren
        ? (largeItem.children as RadioListType[]).map((middleItem) => {
            // 子要素があるか
            const hasGrandChildren = !!middleItem.children && middleItem.children.length > 0;
            // 子要素が選択されている場合はあらかじめ開いておく
            const isOpen =
              hasGrandChildren && (middleItem.children as RadioListType[]).some((grandChildItem) => value.value === grandChildItem.value);
            // 子要素が選択されている、または自身が選択されているか

            const isSelected = isOpen || value.value === middleItem.value;
            if (!hasGrandChildren) {
              return {
                ...middleItem,
                isOpen,
                isSelected,
                hasChildren: hasGrandChildren,
                children: [],
              };
            }

            return {
              ...middleItem,
              isOpen,
              isSelected,
              hasChildren,
              children: (middleItem.children as RadioListType[]).map((grandChildItem) => {
                const isOpen = false;
                const isSelected = value.value === grandChildItem.value;

                return {
                  ...grandChildItem,
                  isOpen,
                  isSelected,
                  hasChildren: false,
                  children: [],
                };
              }),
            };
          })
        : [];

      const isOpen = hasChildren && middle.some((item) => item.isSelected);
      const isSelected = isOpen || value.value === largeItem.value;

      return {
        ...largeItem,
        isOpen,
        isSelected,
        hasChildren,
        children: middle,
      };
    });
  },
  { immediate: true }
);

watchEffect(() => {
  list.value = list.value.map((largeItem) => {
    const middle = largeItem.children.map((middleItem) => {
      return {
        ...middleItem,
        isSelected: middleItem.children.some((smallItem) => value.value === smallItem.value) || value.value === middleItem.value,
      };
    });

    return {
      ...largeItem,
      children: middle,
      isSelected:
        largeItem.children.some((middleItem) => value.value === middleItem.value) ||
        value.value === largeItem.value ||
        middle.some((middleItem) => middleItem.isSelected),
    };
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (large) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: large.label
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["modal_contents_list_item_large", { 'is-selected': large.isSelected }])
        }, [
          _createElementVNode("span", {
            class: "modal_contents_list_item_large_label",
            onClick: ($event: any) => (toggleAccordion(large))
          }, [
            (large.type === 'radio')
              ? (_openBlock(), _createElementBlock("label", {
                  key: 0,
                  class: "radio",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _withDirectives(_createElementVNode("input", {
                    class: "radio_input",
                    type: "radio",
                    name: props.name,
                    value: large.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
                  }, null, 8, _hoisted_3), [
                    [_vModelRadio, _unref(value)]
                  ]),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(large.label), 1)
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(large.label), 1)
                ], 64))
          ], 8, _hoisted_2),
          (large.hasChildren)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["modal_contents_list_item_accordion_icon", { 'is-open': large.isOpen }]),
                onClick: ($event: any) => (toggleAccordion(large))
              }, null, 10, _hoisted_5))
            : _createCommentVNode("", true)
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(large.children, (middle) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            key: middle.label
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["modal_contents_list_item_medium", { 'is-selected': middle.isSelected, modal_contents_list_accordion: middle.hasChildren }])
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["modal_contents_list_item_medium_label", { 'is-checked': isChecked(large.value) }]),
                onClick: ($event: any) => (toggleAccordion(middle))
              }, [
                (middle.type === 'radio')
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 0,
                      class: "radio",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        class: "radio_input",
                        type: "radio",
                        name: props.name,
                        value: middle.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
                      }, null, 8, _hoisted_7), [
                        [_vModelRadio, _unref(value)]
                      ]),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(middle.label), 1)
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(middle.label), 1)
                    ], 64))
              ], 10, _hoisted_6),
              (middle.hasChildren)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["modal_contents_list_item_accordion_icon", { 'is-open': middle.isOpen }]),
                    onClick: ($event: any) => (toggleAccordion(middle))
                  }, null, 10, _hoisted_9))
                : _createCommentVNode("", true)
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(middle.children, (small) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                key: small.label
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["modal_contents_list_item_small", { 'is-checked': isChecked(middle.value) || isChecked(large.value) }])
                }, [
                  (small.type === 'radio')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          class: "radio_input",
                          type: "radio",
                          name: props.name,
                          value: small.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
                        }, null, 8, _hoisted_11), [
                          [_vModelRadio, _unref(value)]
                        ]),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(small.label), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 2)
              ])), [
                [_vShow, middle.isOpen]
              ])
            }), 128))
          ])), [
            [_vShow, large.isOpen]
          ])
        }), 128))
      ], 64))
    }), 128))
  ]))
}
}

})